import { FilterModalTypes } from '../../../../../../components/FilterModal';
import { TableHeadItemRecurse } from '../../../../../../components/TableHead';

export const tableHead: TableHeadItemRecurse[] = [
  { title: 'Cliente', flex: 1.6 },
  { title: 'Ativo', flex: 2 },
  { title: 'CNPJ Fundo', flex: 1.3 },
  { title: 'Classificação' },
  { title: 'Tributação' },
  { title: 'Participante' },
  { title: 'Plano', flex: 0.8 },
  { title: 'Data posição', flex: 0.8 },
  { title: 'Valor bruto', flex: 1.2 },
];

export const getPrivatePensionFilters = (
  dynamicFilters: FilterModalTypes.FilterType[]
): FilterModalTypes.FilterType[] => [
  {
    type: 'date',
    fieldName: 'positionDate',
    title: 'Data da posição',
    placeholder: 'Selecione a data da posição',
  },
  ...dynamicFilters,
  {
    type: 'range',
    fieldName: 'grossValue',
    labelType: 'money',
    title: 'Valor bruto',
    min: 0,
    max: 1000000000,
  },
];
